// @flow

import type {
  AppState,
  Screen,
  InitializeSuccessAction,
  SetAppStateAction,
  NavigateAction,
  ScheduleRedirectionAction,
  ShowWarningBarAction,
  HideWarningBarAction
} from '../common/typings.js';

export const INITIALIZE = 'INITIALIZE';
export const INITIALIZE_SUCCESS = 'INITIALIZE_SUCCESS';
export const SET_APP_STATE = 'SET_APP_STATE';
export const NAVIGATE = 'NAVIGATE';
export const SCHEDULE_REDIRECTION = 'SCHEDULE_REDIRECTION';
export const SHOW_WARNING_BAR = 'SHOW_WARNING_BAR';
export const HIDE_WARNING_BAR = 'HIDE_WARNING_BAR';

export function initialize() {
  return {
    type: INITIALIZE
  };
}

export function initializeSuccess(
  guid: string,
  usTimeFormat: boolean,
  origin: string | null,
  kioskSessionId: number | null
): InitializeSuccessAction {
  return {
    type: INITIALIZE_SUCCESS,
    payload: {
      guid,
      usTimeFormat,
      origin,
      kioskSessionId
    }
  };
}

export function setAppState(appState: AppState): SetAppStateAction {
  return {
    type: SET_APP_STATE,
    payload: {
      appState
    }
  };
}

export function navigate(screen: Screen | null, screenProps?: {}): NavigateAction {
  return {
    type: NAVIGATE,
    payload: {
      screen,
      screenProps
    }
  };
}

export function scheduleRedirection(milisecondsToRedirect: number): ScheduleRedirectionAction {
  return {
    type: SCHEDULE_REDIRECTION,
    payload: {
      milisecondsToRedirect
    }
  };
}

export function showWarningBar(message: string): ShowWarningBarAction {
  return {
    type: SHOW_WARNING_BAR,
    payload: {
      message
    }
  };
}

export function hideWarningBar(): HideWarningBarAction {
  return {
    type: HIDE_WARNING_BAR
  };
}
